import React from 'react'
import styled, { css } from 'styled-components'
import { Button, Link, LogoIcon, Text } from '@swapxco/uikit'
import Container from '../../components/Layout/Container'

const StyledFooter = styled.section`
  background: linear-gradient(${({ theme }) => theme.isDark ? '#181A26a0' : 'transparent'}, ${({ theme }) => theme.isDark ? '#181A26a0' : 'transparent'}),
  url("/images/landingpage/footer-bg.svg") no-repeat bottom left,
  linear-gradient(${({ theme }) => theme.isDark ? '#181A26' : '#EAECF3'}, ${({ theme }) => theme.isDark ? '#181A26' : '#EAECF3'});
  color: ${({ theme }) => theme.colors.text};

  .brand {
    padding: 0.25em 0;
    font-size: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 40px;

    svg {
      margin-right: 26px;
    }

    ${({ theme }) => theme.mediaQueries.md} {
      justify-content: initial;
    }
  }

  .container {
    position: relative;
    display: grid;
    padding: 80px 24px;
    grid-gap: 42px;
    grid-template-columns: repeat(2, 1fr);
    text-align: center;

    ${({ theme }) => theme.mediaQueries.md} {
      text-align: left;
      padding: 100px;
      grid-template-columns: repeat(4, 1fr);
    }

    & > div:first-child {
      grid-column: 1 / 3;

      ${({ theme }) => theme.mediaQueries.md} {
        grid-column: 1 / 2;
      }
    }
  }

  .social-links {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 9px;
    margin-bottom: 26px;

    a {
      width: 38px;
      height: 38px;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;

      ${({ theme }) => theme.isDark ? css`
        background: #212940;
        box-shadow: -10px -10px 30px #2F3C5E, 10px 10px 30px #0C0F1E;
        color: white;
      ` : css`
        background: #F0F0F3;
        box-shadow: -5px -5px 20px #FFFFFF, 5px 5px 20px rgba(174, 174, 192, 0.4);
        color: ${theme.colors.primary};
      `}
      svg {
        height: 24px;
        width: 24px;
      }
    }
  }

  nav {
    display: flex;
    flex-direction: column;
    align-items: start;

    .title {
      font-weight: bold;
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 18px;
    }

    a {
      //display: block;
      text-align: left;
      font-size: 16px;
      line-height: 31px;
      margin-bottom: 10px;
      margin-right: auto;
      position: relative;

      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 3px;
        margin-top: -6px;
        background-color: ${({ theme }) => theme.colors.primary};
        flex: 1 0 100%;
        transition: transform 0.6s cubic-bezier(0.87, 0, 0.13, 1);
        transform: scaleX(0);
      }

      &:hover {
        text-decoration: none !important;

        &::after {
          transform: scaleX(1) !important;
        }
      }
    }
  }
}

.support {
  grid-column: 1 / 3;
  
  ${({ theme }) => theme.mediaQueries.md} {
    grid-column: initial;
  }
}

.coin {
  position: absolute;
  right: 24px;
  top: 0;
  height: 85px;
  transform: translateY(-50%);


  ${({ theme }) => theme.mediaQueries.md} {
    height: 135px;
  }
}
`

export default function Footer() {
  return <>
    <StyledFooter>
      <Container className='container'>
        <div>
          <div className='brand'>
            <LogoIcon height='63px' color='currentColor' />
            SwapX
          </div>
          <div className='social-links'>
            <Button as={Link} href="https://t.me/swapx">
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM8.89 13.17L8.903 13.163L9.773 16.033C9.885 16.344 10.039 16.4 10.226 16.374C10.414 16.349 10.513 16.248 10.636 16.13L11.824 14.982L14.374 16.87C14.84 17.127 15.175 16.994 15.291 16.438L16.948 8.616C17.131 7.888 16.811 7.596 16.246 7.828L6.513 11.588C5.849 11.854 5.853 12.226 6.393 12.391L8.89 13.171V13.17Z'
                  fill='currentColor' />
              </svg>
            </Button>
            <Button as={Link} href="https://twitter.com/SwapXco">
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M22.1623 5.65593C21.3989 5.99362 20.5893 6.2154 19.7603 6.31393C20.634 5.79136 21.288 4.96894 21.6003 3.99993C20.7803 4.48793 19.8813 4.82993 18.9443 5.01493C18.3149 4.34151 17.4807 3.89489 16.5713 3.74451C15.6618 3.59413 14.7282 3.74842 13.9156 4.18338C13.1029 4.61834 12.4567 5.30961 12.0774 6.14972C11.6981 6.98983 11.607 7.93171 11.8183 8.82893C10.1554 8.74558 8.52863 8.31345 7.04358 7.56059C5.55854 6.80773 4.24842 5.75097 3.1983 4.45893C2.82659 5.09738 2.63125 5.82315 2.6323 6.56193C2.6323 8.01193 3.3703 9.29293 4.4923 10.0429C3.82831 10.022 3.17893 9.84271 2.5983 9.51993V9.57193C2.5985 10.5376 2.93267 11.4735 3.54414 12.221C4.15562 12.9684 5.00678 13.4814 5.9533 13.6729C5.33691 13.84 4.6906 13.8646 4.0633 13.7449C4.33016 14.5762 4.8503 15.3031 5.55089 15.824C6.25147 16.3449 7.09743 16.6337 7.9703 16.6499C7.10278 17.3313 6.10947 17.8349 5.04718 18.1321C3.98488 18.4293 2.87442 18.5142 1.7793 18.3819C3.69099 19.6114 5.91639 20.264 8.1893 20.2619C15.8823 20.2619 20.0893 13.8889 20.0893 8.36193C20.0893 8.18193 20.0843 7.99993 20.0763 7.82193C20.8952 7.23009 21.6019 6.49695 22.1633 5.65693L22.1623 5.65593Z'
                  fill='currentColor' />
              </svg>
            </Button>
            <Button as={Link} href="https://github.com/swapxteam">
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M12 2C6.475 2 2 6.475 2 12C1.99887 14.0993 2.65882 16.1456 3.88622 17.8487C5.11362 19.5517 6.84615 20.8251 8.838 21.488C9.338 21.575 9.525 21.275 9.525 21.012C9.525 20.775 9.512 19.988 9.512 19.15C7 19.613 6.35 18.538 6.15 17.975C6.037 17.687 5.55 16.8 5.125 16.562C4.775 16.375 4.275 15.912 5.112 15.9C5.9 15.887 6.462 16.625 6.65 16.925C7.55 18.437 8.988 18.012 9.562 17.75C9.65 17.1 9.912 16.663 10.2 16.413C7.975 16.163 5.65 15.3 5.65 11.475C5.65 10.387 6.037 9.488 6.675 8.787C6.575 8.537 6.225 7.512 6.775 6.137C6.775 6.137 7.612 5.875 9.525 7.163C10.3391 6.93706 11.1802 6.82334 12.025 6.825C12.875 6.825 13.725 6.937 14.525 7.162C16.437 5.862 17.275 6.138 17.275 6.138C17.825 7.513 17.475 8.538 17.375 8.788C18.012 9.488 18.4 10.375 18.4 11.475C18.4 15.313 16.063 16.163 13.838 16.413C14.2 16.725 14.513 17.325 14.513 18.263C14.513 19.6 14.5 20.675 14.5 21.013C14.5 21.275 14.688 21.587 15.188 21.487C17.173 20.8168 18.8979 19.541 20.1199 17.8392C21.3419 16.1373 21.9994 14.0951 22 12C22 6.475 17.525 2 12 2Z'
                  fill='currentColor' />
              </svg>
            </Button>
            <Button as={Link} href="https://www.instagram.com/swapxco/">
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M12 2C14.717 2 15.056 2.01 16.122 2.06C17.187 2.11 17.912 2.277 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8305 4.1779 21.224 4.78259 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.987 8.944 22 9.283 22 12C22 14.717 21.99 15.056 21.94 16.122C21.89 17.187 21.722 17.912 21.475 18.55C21.2247 19.2178 20.8311 19.8226 20.322 20.322C19.822 20.8303 19.2173 21.2238 18.55 21.475C17.913 21.722 17.187 21.89 16.122 21.94C15.056 21.987 14.717 22 12 22C9.283 22 8.944 21.99 7.878 21.94C6.813 21.89 6.088 21.722 5.45 21.475C4.78233 21.2245 4.17753 20.8309 3.678 20.322C3.16941 19.8222 2.77593 19.2175 2.525 18.55C2.277 17.913 2.11 17.187 2.06 16.122C2.013 15.056 2 14.717 2 12C2 9.283 2.01 8.944 2.06 7.878C2.11 6.812 2.277 6.088 2.525 5.45C2.77524 4.78218 3.1688 4.17732 3.678 3.678C4.17767 3.16923 4.78243 2.77573 5.45 2.525C6.088 2.277 6.812 2.11 7.878 2.06C8.944 2.013 9.283 2 12 2ZM12 7C10.6739 7 9.40215 7.52678 8.46447 8.46447C7.52678 9.40215 7 10.6739 7 12C7 13.3261 7.52678 14.5979 8.46447 15.5355C9.40215 16.4732 10.6739 17 12 17C13.3261 17 14.5979 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12C17 10.6739 16.4732 9.40215 15.5355 8.46447C14.5979 7.52678 13.3261 7 12 7V7ZM18.5 6.75C18.5 6.41848 18.3683 6.10054 18.1339 5.86612C17.8995 5.6317 17.5815 5.5 17.25 5.5C16.9185 5.5 16.6005 5.6317 16.3661 5.86612C16.1317 6.10054 16 6.41848 16 6.75C16 7.08152 16.1317 7.39946 16.3661 7.63388C16.6005 7.8683 16.9185 8 17.25 8C17.5815 8 17.8995 7.8683 18.1339 7.63388C18.3683 7.39946 18.5 7.08152 18.5 6.75ZM12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9V9Z'
                  fill='currentColor' />
              </svg>
            </Button>
            <Button as={Link} href="https://discord.com/invite/Mt3CqJXF6w">
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M10.076 11C10.676 11 11.162 11.45 11.151 12C11.151 12.55 10.677 13 10.076 13C9.486 13 9 12.55 9 12C9 11.45 9.475 11 10.076 11ZM13.924 11C14.525 11 15 11.45 15 12C15 12.55 14.525 13 13.924 13C13.334 13 12.849 12.55 12.849 12C12.849 11.45 13.323 11 13.924 11ZM18.891 2C20.054 2 21 2.966 21 4.163V23L18.789 21.005L17.544 19.829L16.227 18.579L16.773 20.522H5.109C3.946 20.522 3 19.556 3 18.359V4.163C3 2.966 3.946 2 5.109 2H18.89H18.891ZM14.921 15.713C17.194 15.64 18.069 14.117 18.069 14.117C18.069 10.736 16.587 7.995 16.587 7.995C15.107 6.862 13.697 6.893 13.697 6.893L13.553 7.061C15.302 7.607 16.114 8.395 16.114 8.395C15.1591 7.85699 14.1066 7.51434 13.018 7.387C12.3274 7.309 11.6299 7.31572 10.941 7.407C10.879 7.407 10.827 7.418 10.766 7.428C10.406 7.46 9.531 7.596 8.431 8.09C8.051 8.268 7.824 8.395 7.824 8.395C7.824 8.395 8.678 7.565 10.529 7.019L10.426 6.893C10.426 6.893 9.017 6.862 7.536 7.996C7.536 7.996 6.055 10.736 6.055 14.117C6.055 14.117 6.919 15.639 9.192 15.713C9.192 15.713 9.572 15.241 9.882 14.842C8.575 14.442 8.082 13.602 8.082 13.602C8.082 13.602 8.184 13.676 8.369 13.781C8.379 13.791 8.389 13.802 8.41 13.812C8.441 13.834 8.472 13.844 8.503 13.865C8.76 14.012 9.017 14.127 9.253 14.222C9.675 14.39 10.179 14.558 10.766 14.674C11.6453 14.8464 12.5494 14.8498 13.43 14.684C13.9429 14.5925 14.4433 14.4411 14.921 14.233C15.281 14.096 15.682 13.896 16.104 13.613C16.104 13.613 15.59 14.474 14.242 14.863C14.551 15.262 14.922 15.713 14.922 15.713H14.921Z'
                  fill='currentColor' />
              </svg>
            </Button>
            {/* <Button as={Link} href=""> */}
            {/*   <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'> */}
            {/*     <path */}
            {/*       d='M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM18.67 12C18.6597 11.7185 18.5682 11.446 18.4066 11.2154C18.2449 10.9847 18.02 10.8057 17.7589 10.7C17.4978 10.5943 17.2117 10.5664 16.9351 10.6196C16.6585 10.6729 16.4032 10.805 16.2 11C15.0624 10.2267 13.7252 9.7995 12.35 9.77L13 6.65L15.14 7.1C15.1654 7.33648 15.2743 7.55615 15.4471 7.71958C15.6199 7.88301 15.8453 7.9795 16.0829 7.99172C16.3204 8.00394 16.5545 7.9311 16.7432 7.78626C16.9319 7.64143 17.0627 7.4341 17.1123 7.20147C17.1619 6.96885 17.1269 6.72617 17.0137 6.51701C16.9005 6.30784 16.7164 6.14587 16.4945 6.06019C16.2726 5.9745 16.0275 5.9707 15.8031 6.04948C15.5786 6.12825 15.3896 6.28444 15.27 6.49L12.82 6C12.7799 5.99121 12.7385 5.99046 12.6982 5.99779C12.6578 6.00513 12.6193 6.0204 12.5849 6.04272C12.5505 6.06505 12.5208 6.09398 12.4977 6.12784C12.4745 6.16171 12.4583 6.19983 12.45 6.24L11.71 9.71C10.3179 9.73099 8.96227 10.1585 7.81 10.94C7.65584 10.795 7.47199 10.6852 7.27118 10.6182C7.07037 10.5513 6.85741 10.5288 6.64705 10.5524C6.4367 10.5759 6.23398 10.645 6.05295 10.7546C5.87192 10.8643 5.7169 11.0121 5.59864 11.1876C5.48038 11.3632 5.40171 11.5623 5.36808 11.7713C5.33444 11.9803 5.34665 12.1941 5.40385 12.3979C5.46106 12.6017 5.56189 12.7906 5.69936 12.9515C5.83683 13.1125 6.00766 13.2416 6.2 13.33C6.18874 13.4765 6.18874 13.6235 6.2 13.77C6.2 16.01 8.81 17.83 12.03 17.83C15.25 17.83 17.86 16.01 17.86 13.77C17.8713 13.6235 17.8713 13.4765 17.86 13.33C18.1068 13.2073 18.3138 13.0174 18.4571 12.782C18.6005 12.5467 18.6743 12.2755 18.67 12V12ZM8.67 13C8.67 12.7348 8.77536 12.4804 8.96289 12.2929C9.15043 12.1054 9.40478 12 9.67 12C9.93522 12 10.1896 12.1054 10.3771 12.2929C10.5646 12.4804 10.67 12.7348 10.67 13C10.67 13.2652 10.5646 13.5196 10.3771 13.7071C10.1896 13.8946 9.93522 14 9.67 14C9.40478 14 9.15043 13.8946 8.96289 13.7071C8.77536 13.5196 8.67 13.2652 8.67 13ZM14.48 15.75C13.7705 16.2847 12.8976 16.5568 12.01 16.52C11.1224 16.5568 10.2495 16.2847 9.54 15.75C9.49748 15.6982 9.47575 15.6324 9.47903 15.5655C9.48232 15.4985 9.51039 15.4352 9.55779 15.3878C9.60519 15.3404 9.66852 15.3123 9.73546 15.309C9.80241 15.3057 9.86819 15.3275 9.92 15.37C10.5212 15.811 11.2551 16.0333 12 16C12.7458 16.0406 13.4831 15.8254 14.09 15.39C14.1156 15.3614 14.1468 15.3383 14.1816 15.3222C14.2165 15.3061 14.2543 15.2974 14.2927 15.2965C14.3311 15.2957 14.3693 15.3028 14.4048 15.3173C14.4404 15.3318 14.4725 15.3535 14.4993 15.381C14.5262 15.4085 14.547 15.4412 14.5606 15.4771C14.5743 15.513 14.5804 15.5514 14.5786 15.5897C14.5767 15.6281 14.5671 15.6656 14.5501 15.7001C14.5331 15.7346 14.5093 15.7652 14.48 15.79V15.75V15.75ZM14.3 14.04C14.1022 14.04 13.9089 13.9814 13.7444 13.8715C13.58 13.7616 13.4518 13.6054 13.3761 13.4227C13.3004 13.24 13.2806 13.0389 13.3192 12.8449C13.3578 12.6509 13.453 12.4727 13.5929 12.3329C13.7327 12.193 13.9109 12.0978 14.1049 12.0592C14.2989 12.0206 14.5 12.0404 14.6827 12.1161C14.8654 12.1918 15.0216 12.32 15.1315 12.4844C15.2414 12.6489 15.3 12.8422 15.3 13.04C15.3054 13.1755 15.2832 13.3107 15.2348 13.4373C15.1864 13.564 15.1127 13.6795 15.0182 13.7767C14.9237 13.874 14.8104 13.9511 14.6853 14.0032C14.5601 14.0553 14.4256 14.0815 14.29 14.08L14.3 14.04Z' */}
            {/*       fill='currentColor' /> */}
            {/*   </svg> */}
            {/* </Button> */}
          </div>
          <Text className='copyrights'>© 2021 - SwapX</Text>
        </div>
        <nav>
          <div className='title'>Token</div>
          <a rel='noreferrer' href='https://docs.swapx.co/swapx/tokenomics/xwap-tokenomics'
             target='_blank'>Tokenomics</a>
          <a rel='noreferrer' href='https://docs.swapx.co/swapx/introduction/master' target='_blank'>Whitepaper</a>
          <a rel='noreferrer'
             href='https://pancakeswap.finance/swap?outputCurrency=0x4fe2598b2b29840c42ff1cb1a9cc151b09522a27'
             target='_blank'>Buy $XWAP</a>
          <a rel='noreferrer' href='https://coinmarketcap.com/currencies/swapx' target='_blank'>Historical Market Data</a>
        </nav>
        <nav>
          <div className='title'>About Us</div>
          <a rel='noreferrer' href='https://swapx.co/privacy-policy' target='_blank'>Privacy Policy</a>
          <a rel='noreferrer' href='https://swapx.co/careers'>Careers</a>
          <a rel='noreferrer' href='https://docs.swapx.co/swapx/' target='_blank'>Docs</a>
          <a rel='noreferrer' href='https://t.me/swapxnews' target='_blank'>Announcements</a>
        </nav>
        <nav className='support'>
          <div className='title'>Support</div>
          <a rel='noreferrer' href='mailto:support@swapx.co' target='_blank'>Contact Us</a>
          <a rel='noreferrer' href='https://docs.swapx.co/swapx/help/faq' target='_blank'>F.A.Q</a>
          <a rel='noreferrer' href='mailto:support@swapx.co' target='_blank'>Give us Feedback</a>
        </nav>
        <img src='/images/landingpage/footer-coin.png' alt='' className='coin' />
      </Container>
    </StyledFooter>
  </>
}
